var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.activeItem)?_c(_setup.TextComponent,{attrs:{"item":_setup.activeItem},on:{"update:title":_setup.handleUpdateTitle,"update:description":_setup.handleUpdateDescription}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }